export default {
    API_URL: "http://127.0.0.1:9000",
    APP_NAME: "JungleHouse",
}